"use client"

import { SessionProvider, useSession } from "next-auth/react"
import { useEffect, useRef, type ReactNode } from "react"
import { AuthSessionRecovery } from "@/components/auth-session-recovery"
import { getQueryClient } from "@/lib/react-query"

export function AuthSessionProvider({ children }: { children: ReactNode }) {
  return <SessionProvider basePath="/api/identity" refetchInterval={300} refetchOnWindowFocus>
    <ContextBoundary>{children}</ContextBoundary>
  </SessionProvider>
}

function ContextBoundary({ children }: { children: ReactNode }) {
  const { data, status } = useSession()
  const previous = useRef<string | undefined>(undefined)
  const user = data?.user
  const context = user ? `${user.user_id}:${user.context_revision}:${user.impersonated_tenant_id ?? user.tenant_id}` : ""
  useEffect(() => {
    if (status === "loading" || !user) return
    if (previous.current !== undefined && previous.current !== context) {
      void getQueryClient().cancelQueries()
      getQueryClient().clear()
      if (previous.current) window.location.reload()
    }
    previous.current = context
  }, [context, status, user])
  return <AuthSessionRecovery required={!user} loading={status === "loading"}>{children}</AuthSessionRecovery>
}
